import config from 'config';
import * as actionTypes from './actions';
let date2 = new Date();
let y = date2.getFullYear();
let m = date2.getMonth();
let lastDate = new Date(y, m + 1, 0);

export const initialState = {
    currentTab: 'calendar',
    currentDate: lastDate,
    eventItems: [],
    selectedItem: {},
    modalOpen: false,
    modalType: null,
    reload: false,
    popOverOpen: false,
    popOverAnchor: null,
    anchorEl: false,
    newDate: null,
    upcomingEventCentral: null
};
const customizationReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.setCurrentTab:
            return {
                ...state,
                currentTab: action.currentTab
            };
        case actionTypes.setCurrentDate:
            return {
                ...state,
                currentDate: action.currentDate
            };
        case actionTypes.setEventItems:
            return {
                ...state,
                eventItems: action.eventItems
            };
        case actionTypes.setSelectedItem:
            return {
                ...state,
                selectedItem: action.selectedItem
            };
        case actionTypes.setModalOpen:
            return {
                ...state,
                modalOpen: action.modalOpen
            };
        case actionTypes.setModalType:
            return {
                ...state,
                modalType: action.modalType
            };
        case actionTypes.setReload:
            return {
                ...state,
                reload: action.reload
            };
        case actionTypes.setPopOverOpen:
            return {
                ...state,
                popOverOpen: action.popOverOpen
            };
        case actionTypes.setPopOverAnchor:
            return {
                ...state,
                popOverAnchor: action.popOverAnchor
            };
        case actionTypes.setNewDate:
            return {
                ...state,
                newDate: action.newDate
            };
        case actionTypes.setUpcomingEventCentral:
            return {
                ...state,
                upcomingEventCentral: action.upcomingEventCentral
            };

        default:
            return state;
    }
};
export default customizationReducer;
